document.addEventListener("DOMContentLoaded", function () {
    function replacePriceText(priceElement) {
        const priceText = priceElement.textContent.trim();
        if (priceText === "€0,00 EUR" || priceText === "0,00") {
            // Reemplaza el texto del precio por "Sólo Profesionales"
            priceElement.textContent = "Sólo Profesionales";
            // Aplica estilos adicionales usando una clase
            priceElement.classList.add("price-item--professional");
        }
    }

    function updatePrices() {
        const priceElements = document.querySelectorAll(".price-item.price-item--regular");
        priceElements.forEach(replacePriceText);
    }

    updatePrices();

    const observer = new MutationObserver(updatePrices);
    observer.observe(document.body, { childList: true, subtree: true });
});
